module.exports = __webpack_public_path__ + "static/hiw-a1bef3627e32ecee3be231f72383c913.jpg";